import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, DELETE, EDIT } from "const"
import { Lifecycle } from "server/models"
import { hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_LIFECYCLE,
    StoreType,
    LangType,

    IsOwnerLifecycle,
    addModal,
} from "client/store"
import {
    Link,
    UserIcon,
    DateFormatter,
    TableColumn,
} from "client/components"

const Columns = () => {
    const baseRoute = useSelector((state: StoreType) => state.lifecycle.baseRoute)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const accountList = useSelector((state: StoreType) => state.account.accountList)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editAccess = !project.id
        ? hasAccess(PRM_LIFECYCLE, EDIT)
        : hasProjectAccess(PRM_LIFECYCLE, EDIT)

    const deleteAccess = !project.id
        ? hasAccess(PRM_LIFECYCLE, DELETE)
        : hasProjectAccess(PRM_LIFECYCLE, DELETE)

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
        },
        {
            field: "name",
            header: lang.name,
            cellMinWidth: "150px",
            cellMaxWidth: "300px",
            formatter: (lifecycle: Lifecycle) => {
                const href = `${baseRoute}/${VIEW}/${lifecycle.id}`
                return (
                    <Link
                        href={href}
                        onClick={() => dispatch(addModal({ url: href }))}
                    >
                        {lifecycle.name}
                    </Link>
                )
            },
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "400px",
        },
        {
            field: "type",
            header: lang.type,
            cellMinWidth: "150px",
            formatter: (lifecycle: Lifecycle) => lang[lifecycle.type as keyof LangType],
        },
        {
            field: "owner",
            header: lang.owner,
            cellMinWidth: "150px",
            formatter: (lifecycle: Lifecycle) => {
                const account = accountList[lifecycle.ownerAccount]
                const user = userList[lifecycle.creator]

                if (project.id) return account.name

                return lifecycle.ownerAccount === userData.accountId
                    ? <UserIcon user={user} size="sm" />
                    : account.name
            },
        },
    ]

    if (!project.id) {
        columns.push({
            field: "default",
            header: lang.default,
            cellMinWidth: "100px",
            formatter: (lifecycle: Lifecycle) => (lifecycle.default ? lang.yes : lang.no),
        })
    }

    if (userData.accountId !== 1) {
        columns.push({
            field: "responsible",
            header: lang.responsible,
            cellMinWidth: "150px",
            formatter: (lifecycle: Lifecycle) => {
                const user = userList[lifecycle.responsible]
                return <UserIcon user={user} size="sm" />
            },
        })
    }

    columns.push(
        {
            field: "createdAt",
            header: lang.created,
            formatter: (lifecycle: Lifecycle) => <DateFormatter date={lifecycle.createdAt} />,
        },
        {
            field: "delete",
            centerAlign: true,
            deleteAccess: (lifecycle: Lifecycle) => deleteAccess || IsOwnerLifecycle(project.id, lifecycle, userData),
        },
    )

    if (editAccess) {
        columns.unshift({
            field: "sort",
            centerAlign: true,
        })
    }

    return columns
}
export default Columns
